import { render, staticRenderFns } from "./NoTopicsMessage.vue?vue&type=template&id=69fe53fa&scoped=true"
import script from "./NoTopicsMessage.vue?vue&type=script&lang=js"
export * from "./NoTopicsMessage.vue?vue&type=script&lang=js"
import style0 from "./NoTopicsMessage.vue?vue&type=style&index=0&id=69fe53fa&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fe53fa",
  null
  
)

export default component.exports